import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email("Invalid email address"),
  password: z.string().min(6, "Password must be at least 6 characters"),
});

export type LoginFormValues = z.infer<typeof loginSchema>;

export interface LoginResponse {
  success: boolean;
  error: string | null;
}

export const forgotPasswordSchema = z.object({
  email: z.string().email("Invalid email address"),
});

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z
  .object({
    password: z.string().min(6, "Password must be at least 6 characters"),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role?: string;
  tenant_id?: string;
  locationId?: string | null;
  preferredLanguage?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

/** Account row when login or forgot-password requires tenant selection */
export interface AuthAccountOption {
  accountId: string;
  accountName: string | null;
  userName: string;
  role: string;
}

export type LoginApiResult =
  | { type: "success"; user: User; token: string }
  | { type: "account_selection"; accounts: AuthAccountOption[] }
  | { type: "error"; message: string };

export type PasswordResetRequestResult =
  | { type: "success" }
  | { type: "account_selection"; accounts: AuthAccountOption[] }
  | { type: "failure"; error: string | null; isRateLimited: boolean };
